// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"edge-color_colorPicker__1WL6v","colorPickerBtn":"edge-color_colorPickerBtn__1OoMb","picker":"edge-color_picker__ahYkj"};